import { defineMessages } from 'react-intl';

const messages = defineMessages({
  defaultTitle: {
    description: 'bulkPresetDropdown.defaultTitle',
    defaultMessage: 'Select a Preset',
    id: 'xFi2Xr',
  },
});

export default messages;
